export default __webpack_public_path__ + "static/media/right-arrow4.127fd9af.png";